import React, { useState } from "react";
import styled from "styled-components";
const SearchWidgetContainer = styled.div `
	vertical-align: top;
	display: inline-block;
	position: relative;

	& ~ & {
		margin-left: 30px;
	}
`;
const Scorer = styled.div `
	width: 516px;
`;
const Selector = styled.div `
	height: 1.5em;
`;
const Label = styled.label `
	font-weight: bold;
	margin-right: .5em;
	color: #666;
`;
export default function ScorerSelector({ configs, onChange, onKbdClick }) {
    const [selectedIndex, setSelectedIndex] = useState(0);
    const items = configs.map(({ adapter: { name } }, i) => (React.createElement("option", { key: i, value: i }, name)));
    const [leftDescription, rightDescription] = configs[selectedIndex].description;
    function handleChange(event) {
        var _a;
        const newSelectedIndex = Number((_a = event.target) === null || _a === void 0 ? void 0 : _a.value);
        onChange(configs[newSelectedIndex]);
        setSelectedIndex(newSelectedIndex);
    }
    return (React.createElement("div", null,
        React.createElement(SearchWidgetContainer, null,
            React.createElement(Scorer, null,
                React.createElement(Selector, null,
                    React.createElement(Label, null, "Scorer:"),
                    "QuickScore"),
                React.createElement("div", { onClick: onKbdClick }, leftDescription))),
        React.createElement(SearchWidgetContainer, null,
            React.createElement(Scorer, null,
                React.createElement(Selector, null,
                    React.createElement(Label, { htmlFor: "menu" }, "Scorer:"),
                    React.createElement("select", { id: "menu", onChange: handleChange }, items)),
                React.createElement("div", { onClick: onKbdClick }, rightDescription)))));
}
